import * as yup from 'yup';
import { useI18n } from 'vue-i18n';
import { useJobBoardStore } from '@/core/collections/job-boards/job-board.store';
import { storeToRefs } from 'pinia';
import { buildLanguageFields } from '@/core/helpers/yup-validation.helper';

export function getRules() {
   const { t } = useI18n();
   const jobBoardStore = useJobBoardStore();
   const { currentJobBoard } = storeToRefs(jobBoardStore);

   const languageFields = buildLanguageFields(currentJobBoard.value?.languages);
   return yup.object({});
}
